import { lazy } from 'react';

import { AppRoute } from './';

const Projects = lazy(() => import('../pages/projects/Projects'));
const Project = lazy(() => import('../pages/projects/Project'));
const ProjectRecordings = lazy(() => import('../pages/projects/ProjectRecordings'));
const StreetViewProjectEditor = lazy(() => import('../pages/projects/StreetViewProjectEditor'));
const StreetViewProjects = lazy(() => import('../pages/projects/StreetViewProjects'));

const projectsRouter: AppRoute[] = [{
    path: '/projects',
    component: Projects,
    exact: true
}, {
    path: '/editor/:id',
    component: Project,
    exact: true
}, {
    path: '/recordings',
    component: ProjectRecordings,
    exact: true
}, {
    path: '/street-view',
    component: StreetViewProjects,
    exact: true
}, {
    path: '/street-view/:id',
    component: StreetViewProjectEditor,
    exact: true
}];

export default projectsRouter;
